import React from 'react';

const MongoDB_DataAPI = () => {
  return (
    <div>
      <h1>MongoDB_DataAPI Component</h1>
      <p>This is the MongoDB_DataAPI page.</p>
    </div>
  );
};

export default MongoDB_DataAPI;
